import { Power2, gsap } from 'gsap';
import {
  device,
  toArray,
} from '../helpers/helpers';

export default class {
  constructor(selector) {
    this.getRefs(selector);
    this.currentIndex = 0;
    this.totalSlides = this.refs.slides.length;
    this.direction = 'rtl';
    this.isAnimating = false;
    this.timeline = gsap.timeline();
    this.initialize();
  }

  getRefs(selector) {
    const el = document.querySelector(selector);
    const navigation = el.querySelector('.slider-nav');
    const pagination = el.querySelector('.slider-pagination');
    const slider = el.querySelector('.slider-photographs__slider');
    const slides = el.querySelectorAll('.slider-photographs__slide');

    this.el = el;
    this.refs = {
      navigation: this.getNavigationRefs(navigation),
      pagination: {
        bullets: toArray(pagination.children),
      },
      slider,
      slides: this.getSlidesRefs(slides),
    };
  }

  getNavigationRefs(navigation) {
    return {
      previous: navigation.querySelector('.prev'),
      next: navigation.querySelector('.next'),
    };
  }

  getSlidesRefs(slides) {
    return toArray(slides).map(this.getSlideRefs);
  }

  getSlideRefs(slide) {
    slide.refs = {
      image: slide.querySelector('img'),
      text: device().isMobile
        ? slide.querySelector(
            '.slider-photographs__mobile .slider-photographs__text',
          )
        : slide.querySelector(
            '.slider-photographs__caption .slider-photographs__text',
          ),
      title: slide.querySelector('.slider-photographs__title'),
      graphic: slide.querySelector('.quote'),
    };
    return slide;
  }

  initialize() {
    //this.initializeSwiperHeight(); // TODO pas compris cette merde
    this.initializeNavigation();
    this.initializePagination();
    this.setActiveBullet();
    this.gotoPanel(0);
  }

  async initializeSwiperHeight() {
    // it seems it's to ensure all tabsets have the same height so that switching from one to another does not create any jump
    // this is really annoying and hacky code, rather reimplement this another way ..
    /*
    try {
      const imagePaths = this.refs.slides.map(this.getImagesPath);
      await loadImages(imagePaths);
      const slideHeights = this.refs.slides.map(getElementHeight);
      const swiperHeight = Math.max(...slideHeights, 0);
      this.refs.slider.style.height = `${swiperHeight}px`;
    } catch (error) {
      console.error('Error while setting tabset height');
    }
    */
  }

  getImagesPath(slide) {
    return slide.refs.image.src;
  }

  initializeNavigation() {
    this.refs.navigation.previous.addEventListener('click', (event) => {
      this.linkEventCallback(event, -1);
    });
    this.refs.navigation.next.addEventListener('click', (event) => {
      this.linkEventCallback(event, 1);
    });
  }

  initializePagination() {
    this.refs.pagination.bullets.map((bullet, index) =>
      bullet.addEventListener('click', (event) => {
        this.setBulletEvent(event, index);
      }),
    );
  }
  setBulletEvent(event, index) {
    event.preventDefault();
    this.gotoPanel(index);
  }

  linkEventCallback(event, direction) {
    event.preventDefault();
    if (!this.isAnimating) {
      let newIndex = this.currentIndex + direction;
      if (newIndex < 0) {
        newIndex = this.totalSlides - 1;
      }
      if (newIndex === this.totalSlides) {
        newIndex = 0;
      }
      this.gotoPanel(newIndex);
    }
  }

  setActiveBullet() {
    this.refs.pagination.bullets.forEach((bullet) =>
      bullet.classList.remove('active'),
    );
    this.refs.pagination.bullets[this.currentIndex].classList.add('active');
  }

  gotoPanel(index) {
    if (index !== this.currentIndex) {
      const movingPanels = {
        leaving: this.refs.slides[this.currentIndex],
        entering: this.refs.slides[index],
      };

      this.direction = this.getDirection(this.currentIndex, index);
      this.currentIndex = index;
      this.isAnimating = true;

      movingPanels.leaving.classList.add('active');

      this.timeline.clear();
      this.setActiveBullet();
      this.setTimelineForDesktop(movingPanels);
    } else {
      this.refs.slides[index].classList.add('active');
      this.refs.slides[index].style.zIndex = 0;
    }
  }

  setTimelineForDesktop(panels) {
    const { entering, leaving } = panels;
    this.timeline
      .fromTo(
        leaving.refs.image,
        { x: 0, alpha: 1 },
        {
          duration: 0.3,
          x: -35 * this.direction,
          alpha: 0,
       //   easing: Power2.easeIn,
        },
      )
      .fromTo(
        leaving.refs.text,
        { x: 0, alpha: 1 },
        {
          duration: 0.3,
          x: -40 * this.direction,
          alpha: 0,
          // easing: Power2.easeIn,
        },
        '-=0.3',
      )
      .fromTo(
        leaving.refs.title,
        { x: 0, alpha: 1 },
        {
          duration: 0.3,
          x: -45 * this.direction,
          alpha: 0,
          //easing: Power2.easeIn,
        },
        '-=0.3',
      )
      .fromTo(
        leaving.refs.graphic,
        { x: 0, alpha: 1 },
        {
          duration: 0.3,
          x: -20 * this.direction,
          alpha: 0,
          //easing: Power2.easeIn,
        },
        '-=0.3',
      )
      .call(() => {
        leaving.classList.remove('active');
        leaving.style.zIndex = null;
        entering.classList.add('active');
        entering.style.zIndex = 0;
      })
      .fromTo(
        entering.refs.image,

        { x: 35 * this.direction, alpha: 0 },
        {
          duration: 0.3,
          x: 0,
          alpha: 1,
          //  easing: Power2.easeOut
        },
      )
      .fromTo(
        entering.refs.text,
        { x: 40 * this.direction, alpha: 0 },
        {
          duration: 0.3,
          x: 0,
          alpha: 1,
          //  easing: Power2.easeOut
        },
        '-=0.3',
      )
      .fromTo(
        entering.refs.title,
        { x: 45 * this.direction, alpha: 0 },
        {
          duration: 0.3,
          x: 0,
          alpha: 1,
          //  easing: Power2.easeOut
        },
        '-=0.3',
      )
      .fromTo(
        entering.refs.graphic,
        { x: 20 * this.direction, alpha: 0 },
        {
          duration: 0.3,
          x: 0,
          alpha: 1,
          //easing: Power2.easeOut
        },
        '-=0.3',
      )
      .call(() => {
        this.isAnimating = false;
      });
  }

  getDirection(index, nextIndex) {
    let direction = 1;
    const isNextSlide = nextIndex > index;
    const isLoopingFromEnd = nextIndex === 0 && index === this.totalSlides - 1;
    const isLoopingFromStart =
      nextIndex === this.totalSlides - 1 && index === 0;

    if (isNextSlide || isLoopingFromEnd) {
      direction = -1;
    }
    if (isLoopingFromStart) {
      direction = 1;
    }

    return direction;
  }
}
